import type { ReactNode } from "react";
import { operationalTheme } from "./operationalStyles";

type OperationalEmptyStateProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
};

export function OperationalEmptyState({
  icon,
  title,
  description,
  action,
}: OperationalEmptyStateProps) {
  return (
    <div
      style={{
        minHeight: "16rem",
        padding: "3rem 1.25rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "2.75rem",
          height: "2.75rem",
          borderRadius: "0.55rem",
          marginBottom: "0.85rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "color-mix(in srgb, var(--login-accent) 8%, transparent)",
          color: operationalTheme.accent,
        }}
      >
        {icon}
      </div>
      <p style={{ margin: 0, fontWeight: 650, color: operationalTheme.text }}>
        {title}
      </p>
      {description ? (
        <p
          style={{
            margin: "0.3rem 0 0",
            maxWidth: "20rem",
            fontSize: "0.84rem",
            color: operationalTheme.muted,
          }}
        >
          {description}
        </p>
      ) : null}
      {action ? <div style={{ marginTop: "1rem" }}>{action}</div> : null}
    </div>
  );
}
